// extracted by mini-css-extract-plugin
export var addButton = "_fo-0";
export var border = "_fo-8";
export var check = "_fo-h";
export var danger = "_fo-6";
export var dropdownContainer = "_fo-1";
export var editModalBody = "_fo-j";
export var footerContainer = "_fo-i";
export var fullWidth = "_fo-a";
export var hide = "_fo-9";
export var icon = "_fo-3";
export var input = "_fo-7";
export var inputFlex = "_fo-b";
export var inputWrapper = "_fo-c";
export var manualFocus = "_fo-5";
export var optionButton = "_fo-4";
export var pillWrapper = "_fo-e";
export var pointer = "_fo-2";
export var showOverflow = "_fo-f";
export var tagsFlex = "_fo-d";
export var xButton = "_fo-g";